// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-title{padding:0;border:0}`, "",{"version":3,"sources":["webpack://./src/utils/css/design-system-overrides.scss"],"names":[],"mappings":"AAQA,cACE,SAAA,CACA,QAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n// 既存画面のスタイルとデザインシステムのスタイルが衝突したときの共通調整を置く。\n// このリポジトリの SCSS は CSS Modules で処理されるが、h2 などの要素セレクタは\n// 画面内に閉じず、デザインシステムのモーダル見出しにも適用される。\n// その結果、既存画面の余白や下線が DialogTitle の配置を崩すことがある。\n// 各画面の h2 ルールに除外条件を増やすと修正が分散するため、対象の部品に限って\n// このファイルで衝突する指定を打ち消す。:global() はデザインシステムのクラス名を\n// CSS Modules に変換させず、そのまま選択するために使う。\n:global(.dialog-title) {\n  padding: 0;\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": `56px`,
	"lCompanyHeight": `114px`,
	"h2FontSize": `28px`,
	"h3FontSize": `20px`,
	"bodyLineHeight": `20px`,
	"lGnShrinkWindowWidth": `1591px`,
	"tableVerticalPadding": `8px`,
	"tableHorizontalPadding": `16px`,
	"lPersonnelBreakWidth": `1599px`,
	"cNavigationAccent": `#f57f17`,
	"cTableBodyOdd": `#fff`,
	"cTableBodyEven": `#f2f6f8`,
	"cTableHover": `#c5ddeb`,
	"cTableHeadOdd": `#eaf1f5`,
	"cTableHeadEven": `#dee8ef`,
	"zPageLoading": `2`
};
export default ___CSS_LOADER_EXPORT___;
